import { render, staticRenderFns } from "./RadioCheckboxField.vue?vue&type=template&id=cf2b53cc&scoped=true&"
import script from "./RadioCheckboxField.vue?vue&type=script&lang=js&"
export * from "./RadioCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2b53cc",
  null
  
)

export default component.exports